import { CustomerCard } from "@src/interface/Customer";
import useBackboneContext from "../provider/useBackboneContext";
import useResponsive from "@src/hooks/useResponsive";

function isCardExpired(card: CustomerCard) {
  // Utiliser une expression régulière pour extraire le mois et l'année
  const regex = /^(\d{2})(\d{2})$/;
  const match = card?.expiryDate?.match(regex);

  if (match) {
    const month = parseInt(match[1], 10);
    const year = parseInt(match[2], 10) + 2000; // Convertir en année complète

    // Obtenir la date actuelle
    const currentDate = new Date();

    // Calculer le premier jour du mois suivant
    const expirationDate = new Date(year, month, 0, 23, 59, 59); // Le jour 0 renvoie le dernier jour du mois précédent, à la dernière seconde.

    // Comparer la date d'expiration avec la date actuelle
    return expirationDate < currentDate;
  } else {
    // Par défaut, la carte n'est pas expirée
    return false;
  }
}

const useFormatCardDetails = () => {
  const { app } = useBackboneContext();
  const { isMobile } = useResponsive();
  function formatExpire(card: CustomerCard) {
    let expire = card.expiryDate || "";
    if (expire)
      expire = app.t(
        "expire en %s",
        "Checkout",
        expire.replace(/^(\d\d)(\d\d)$/, "$1/$2")
      );
    return expire;
  }

  function formatCardName(rawCardName: string, shortX?: boolean) {
    return (rawCardName || "")
      .replace(shortX || isMobile ? /X+/g : /X{3,4}/g, "•••• ")
      .replace(/([\d]{4})/g, "$1 ")
      .replace(/X/gi, "•")
      .trim();
  }

  return { formatExpire, formatCardName };
};

export { isCardExpired };

export default useFormatCardDetails;
